/**
 * L'état d'interface de la boutique, pur : la feuille d'un geste (fermée, sa fiche, l'accusé de son
 * achat), le geste ouvert, la quête de Tina telle que la réponse de l'achat l'a servie, et l'avis
 * d'un geste qui n'est pas passé.
 *
 * Le geste reste nommé quand la feuille se ferme : elle se referme sur lui au lieu de disparaître.
 */
import { type ApiGameSkillSet } from "../../../../adapters/student/shared/questAdapter"

export type ShopSheetStep = "closed" | "detail" | "purchased"

/** Le geste ouvert : ce que l'achat et le partage en lisent. */
export type OpenGesture = { id: number; name: string }

export type StudentShopUiState = {
    step: ShopSheetStep
    gesture: OpenGesture | null
    /** La quête de Tina dans la réponse de l'achat (`skill_sets` de la réponse). */
    gesturesSkillSet: ApiGameSkillSet | null
    notice: string | null
}

export type StudentShopUiAction =
    | { type: "OPEN"; gesture: OpenGesture }
    | { type: "CLOSE" }
    | { type: "PURCHASED"; gesturesSkillSet: ApiGameSkillSet | null }
    | { type: "PURCHASE_FAILED"; message: string }
    | { type: "FAILED"; message: string }
    | { type: "DISMISS_NOTICE" }

export const initialStudentShopUiState: StudentShopUiState = {
    step: "closed",
    gesture: null,
    gesturesSkillSet: null,
    notice: null,
}

export function studentShopUiReducer(state: StudentShopUiState, action: StudentShopUiAction): StudentShopUiState {
    switch (action.type) {
        case "OPEN":
            return { ...state, step: "detail", gesture: action.gesture, gesturesSkillSet: null }
        case "CLOSE":
            return { ...state, step: "closed" }
        case "PURCHASED":
            // Comme l'ancien écran, qui poussait toujours ses félicitations : l'achat est fait, il se dit.
            return { ...state, step: "purchased", gesturesSkillSet: action.gesturesSkillSet }
        case "PURCHASE_FAILED":
            // `MyPetalsTabScreen.js` : un achat refusé referme la fiche, et se dit.
            return { ...state, step: "closed", notice: action.message }
        case "FAILED":
            return { ...state, notice: action.message }
        case "DISMISS_NOTICE":
            return { ...state, notice: null }
        default:
            return state
    }
}
